if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.quantitySelector = this.querySelector("select[name=quantity]");
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]') ? this.querySelector('[type="submit"]') : this.querySelector("recharge-bundle-add-to-cart .button");
        if (document.querySelector("cart-drawer") && this.submitButton)
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        //If product has tag of order_limit_3. Limit the quantity up to 3.
        if (this.quantitySelector && this.quantitySelector.classList.contains("order_limit_3")) {
          if (this.form.querySelector(".over_limit_message")) {
            this.form.querySelector(".over_limit_message").remove();
          }
          let cart = await fetch("/cart.js");
          cart = await cart.json();
          let existProductQuantity = 0;
          cart.items.forEach((i) => {
            if (i.variant_id == this.form.id.value) {
              existProductQuantity = i.quantity;
            }
          });

          let totalQuantity =
            parseInt(this.quantitySelector.value) + parseInt(existProductQuantity);
          if (totalQuantity > 3) {
            console.log(" over 3");
            if (!this.form.querySelector(".over_limit_message")) {
              let overLimitMessage = document.createElement("p");
              overLimitMessage.classList.add("over_limit_message");
              overLimitMessage.innerText = "This product has a limit of 3 per order";
              this.form.append(overLimitMessage);
            }
            return;
          }
        }

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let frequencySelector = document.querySelector(".rc_select__frequency");
        let duplicatedSelector = document.getElementById("rc_duplicate_selector");
        if (
          frequencySelector &&
          duplicatedSelector &&
          frequencySelector.options[frequencySelector.selectedIndex].hasAttribute("data-handle")
        ) {
          let variant_handle =
            frequencySelector.options[frequencySelector.selectedIndex].getAttribute("data-handle");

          if (variant_handle) {
            duplicatedSelector.options.forEach(function (element, index) {
              if (element.getAttribute("data-handle") == variant_handle) {
                duplicatedSelector.selectedIndex = index;
              }
            });
          }
        }

        if (this.form.classList.contains("form-subscription")) {
          // Subscription Function
          const formData = new FormData(this.form);
          if (this.submitButton.dataset.subscriptionType == "new") {
            if (formData.get("purchase_type") == "autodeliver") {
              formData.append("address_id", document.querySelector("#select_address_id").value);
              formData.append(
                "next_charge_scheduled_at",
                document.querySelector("#next_charge_date").value
              );
              formData.append("shopify_variant_id", formData.get("id"));

              // FYI: removing these properties adds the product as an OTP
              formData.append("order_interval_unit", "week");
              formData.append(
                "order_interval_frequency",
                formData.get("properties[_charge_interval_frequency]")
              );
              formData.append(
                "charge_interval_frequency",
                formData.get("properties[_charge_interval_frequency]")
              );
              // var subscriptionHeader = new Headers();
              // subscriptionHeader.append("X-Recharge-Access-Token", "9e594c2096cea610aac424e052775ed3cdf98dc553b009a6a7a31210");
              // subscriptionHeader.append("X-Recharge-Version", "2021-11");
              // subscriptionHeader.append("Content-Type", "application/json");

              var requestOptions = {
                method: "POST",
                body: formData,
              };

              fetch(
                window.location.href.replace("subscriptions/new", "subscriptions"),
                requestOptions
              )
                .then((response) => response.json())
                .then((result) => {
                  window.location.href =
                    window.LOLA_PRODUCT.metadata.rechargeInfo.subscriptionsListUrl;
                })
                .catch((error) => console.log(error))
                .finally(() => {
                  this.submitButton.classList.remove("loading");
                  if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                  this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                });
            } else {
              if (this.cart) {
                formData.append(
                  "sections",
                  this.cart.getSectionsToRender().map((section) => section.id)
                );
                formData.append("sections_url", window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
              }
              config.body = formData;

              let upsellProductElement = document.querySelector(
                ".upsell-product--wrapper .add-form-selector"
              );
              if (
                upsellProductElement &&
                upsellProductElement.classList.contains("active") &&
                upsellProductElement.hasAttribute("data-variant-id")
              ) {
                const upsell_data = {
                  items: [
                    {
                      quantity: 1,
                      id: upsellProductElement.getAttribute("data-variant-id"),
                    },
                  ],
                };

                fetch(window.Shopify.routes.root + "cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(upsell_data),
                })
                  .then((response) => {
                    return response.json();
                  })
                  .catch((error) => {
                    console.error("Error:", error);
                  })
                  .finally(() => {
                    fetch(`${routes.cart_add_url}`, config)
                      .then((response) => response.json())
                      .then((response) => {
                        if (response.status) {
                          this.handleErrorMessage(response.description);

                          const soldOutMessage =
                            this.submitButton.querySelector(".sold-out-message");
                          if (!soldOutMessage) return;
                          this.submitButton.setAttribute("aria-disabled", true);
                          this.submitButton.querySelector("span").classList.add("hidden");
                          soldOutMessage.classList.remove("hidden");
                          this.error = true;
                          return;
                        } else if (!this.cart) {
                          window.location = window.routes.cart_url;
                          return;
                        }

                        this.error = false;
                        const quickAddModal = this.closest("quick-add-modal");
                        if (quickAddModal) {
                          document.body.addEventListener(
                            "modalClosed",
                            () => {
                              setTimeout(() => {
                                this.cart.renderContents(response);
                              });
                            },
                            { once: true }
                          );
                          quickAddModal.hide(true);
                        } else {
                          this.cart.renderContents(response);
                        }
                      })
                      .catch((e) => {
                        console.error(e);
                      })
                      .finally(() => {
                        this.submitButton.classList.remove("loading");
                        if (this.cart && this.cart.classList.contains("is-empty"))
                          this.cart.classList.remove("is-empty");
                        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                      });
                  });
              } else {
                // Add OTP to existing subscription
                // console.log("OTP");

                formData.append("address_id", document.querySelector("#select_address_id").value);
                formData.append(
                  "next_charge_scheduled_at",
                  document.querySelector("#next_charge_date").value
                );
                formData.append("shopify_variant_id", formData.get("id"));

                var requestOptions = {
                  method: "POST",
                  body: formData,
                };

                const url = window.location.href
                  .replace("subscriptions/new", "onetimes")
                  .replace("subscriptions", "onetimes");
                // this is just the addition of OTP on an existing subscription
                fetch(url, requestOptions)
                  .then((response) => response.json())
                  .then((response) => {
                    window.location.href =
                      window.LOLA_PRODUCT.metadata.rechargeInfo.subscriptionsListUrl;
                  })
                  .catch((e) => {
                    console.error(e);
                  })
                  .finally(() => {
                    this.submitButton.classList.remove("loading");
                    if (this.cart && this.cart.classList.contains("is-empty"))
                      this.cart.classList.remove("is-empty");
                    if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                    this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                  });
              }
            }
          } else if (this.submitButton.dataset.subscriptionType == "edit") {
            if (formData.get("purchase_type") == "autodeliver") {
              const subscriptionForm = new FormData(
                document.querySelector("#_ReChargeForm_subscription")
              );
              for (var pair of subscriptionForm.entries()) {
                if (
                  formData.get("properties[_charge_interval_frequency]") &&
                  (pair[0] == "order_interval_frequency" || pair[0] == "charge_interval_frequency")
                ) {
                  //updating order_interval_frequency and charge_interval_frequency
                  formData.append(pair[0], formData.get("properties[_charge_interval_frequency]"));
                } else {
                  formData.append(pair[0], pair[1]);
                }
              }

              formData.append("shopify_variant_id", formData.get("id"));

              let product_id;
              if (document.querySelector(`product-form input#variant_id`)) {
                product_id = document
                  .querySelector(`product-form input#variant_id`)
                  .getAttribute("data-productid");
              }

              if (
                document.querySelector(`option.rc_subscription_variant_id.product_id_${product_id}`)
              ) {
                let variant_id = document.querySelector(
                  `option.rc_subscription_variant_id.product_id_${product_id}`
                ).value;
                formData.set("variant_id", variant_id);
                formData.set("shopify_variant_id", variant_id);
                formData.set("id", product_id);
              }

              var requestOptions = {
                method: "POST",
                body: formData,
              };

              fetch(
                window.location.href.replace("subscriptions/new", "subscriptions"),
                requestOptions
              )
                .then((response) => response.json())
                .then((result) => {
                  window.location.href =
                    window.LOLA_PRODUCT.metadata.rechargeInfo.subscriptionsListUrl;
                })
                .catch((error) => console.log(error))
                .finally(() => {
                  this.submitButton.classList.remove("loading");
                  if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                  this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                });
            } else {
              if (this.cart) {
                formData.append(
                  "sections",
                  this.cart.getSectionsToRender().map((section) => section.id)
                );
                formData.append("sections_url", window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
              }
              config.body = formData;

              let upsellProductElement = document.querySelector(
                ".upsell-product--wrapper .add-form-selector"
              );
              if (
                upsellProductElement &&
                upsellProductElement.classList.contains("active") &&
                upsellProductElement.hasAttribute("data-variant-id")
              ) {
                const upsell_data = {
                  items: [
                    {
                      quantity: 1,
                      id: upsellProductElement.getAttribute("data-variant-id"),
                    },
                  ],
                };

                fetch(window.Shopify.routes.root + "cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(upsell_data),
                })
                  .then((response) => {
                    return response.json();
                  })
                  .catch((error) => {
                    console.error("Error:", error);
                  })
                  .finally(() => {
                    fetch(`${routes.cart_add_url}`, config)
                      .then((response) => response.json())
                      .then((response) => {
                        if (response.status) {
                          this.handleErrorMessage(response.description);

                          const soldOutMessage =
                            this.submitButton.querySelector(".sold-out-message");
                          if (!soldOutMessage) return;
                          this.submitButton.setAttribute("aria-disabled", true);
                          this.submitButton.querySelector("span").classList.add("hidden");
                          soldOutMessage.classList.remove("hidden");
                          this.error = true;
                          return;
                        } else if (!this.cart) {
                          window.location = window.routes.cart_url;
                          return;
                        }

                        this.error = false;
                        const quickAddModal = this.closest("quick-add-modal");
                        if (quickAddModal) {
                          document.body.addEventListener(
                            "modalClosed",
                            () => {
                              setTimeout(() => {
                                this.cart.renderContents(response);
                              });
                            },
                            { once: true }
                          );
                          quickAddModal.hide(true);
                        } else {
                          this.cart.renderContents(response);
                        }
                      })
                      .catch((e) => {
                        console.error(e);
                      })
                      .finally(() => {
                        this.submitButton.classList.remove("loading");
                        if (this.cart && this.cart.classList.contains("is-empty"))
                          this.cart.classList.remove("is-empty");
                        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                      });
                  });
              } else {
                // attempting to convert a subscription to a OTP is using this
                // console.log('is anything else using this??')

                // formData.append(
                //   "address_id",
                //   document.querySelector("#select_address_id").value
                // );
                // formData.append(
                //   "next_charge_scheduled_at",
                //   document.querySelector("#next_charge_date").value
                // );
                formData.append("shopify_variant_id", formData.get("id"));

                var requestOptions = {
                  method: "POST",
                  body: formData,
                };

                // https://theme.rechargepayments.com/#post-update-subscription

                const url = window.location.href.replace("subscriptions/new", "subscriptions");
                // this is just the addition of OTP on an existing subscription
                fetch(url, requestOptions)
                  .then((response) => response.json())
                  .then((response) => {
                    window.location.href =
                      window.LOLA_PRODUCT.metadata.rechargeInfo.subscriptionsListUrl;
                  })
                  .catch((e) => {
                    console.error(e);
                  })
                  .finally(() => {
                    this.submitButton.classList.remove("loading");
                    if (this.cart && this.cart.classList.contains("is-empty"))
                      this.cart.classList.remove("is-empty");
                    if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                    this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                  });
              }
            }
          }

          // const formData = {
          //   address_id: '',
          //   charge_interval_frequency: '',
          //   next_charge_scheduled_at: '',
          //   order_interval_frequency: '',
          //   order_interval_unit: '',
          //   quantity: '',
          //   external_variant_id: '',
          // }

          // fetch(`https://api.rechargeapps.com/subscriptions`, requestOptions)
          //   .then(response => response.json())
          //   .then(result => console.log(result))
          //   .catch(error => console.log(error))
          //   .finally(() => {

          //   });
        } else {
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          //This is for checking if the product is the custom products.
          if (this.form.querySelector("#rc_container")) {
            if (document.querySelector(".rc_block.rc_block__type__onetime")?.classList.contains("rc_block__type--active")) {
              console.log(this.form["id"]);
            } else {
              //needs to get correct variant id and product id for the config data.
              if (document.querySelector(`product-form input#variant_id`)) {
                let product_id = document
                  .querySelector(`product-form input#variant_id`)
                  .getAttribute("data-productid");
                if (
                  document.querySelector(
                    `option.rc_subscription_variant_id.product_id_${product_id}`
                  )
                ) {
                  let variant_id = document.querySelector(
                    `option.rc_subscription_variant_id.product_id_${product_id}`
                  ).value;
                  console.log(
                    document.querySelector(
                      `option.rc_subscription_variant_id.product_id_${product_id}`
                    )
                  );
                  console.log("variant_id: ", variant_id);
                  formData.set("id", variant_id);
                }
              }
            }
          }
          config.body = formData;

          let upsellProductElement = document.querySelector(
            ".upsell-product--wrapper .add-form-selector"
          );
          if (
            upsellProductElement &&
            upsellProductElement.classList.contains("active") &&
            upsellProductElement.hasAttribute("data-variant-id")
          ) {
            let upsellWrapper = document.querySelector(".upsell-product--wrapper");
            let upsell_data;
            if (upsellWrapper.dataset.frequency) {
              upsell_data = {
                items: [
                  {
                    quantity: 1,
                    id: upsellProductElement.getAttribute("data-variant-id"),
                    purchase_type: "autodeliver",
                    properties: {
                      shipping_interval_frequency: upsellWrapper.dataset.frequency,
                      shipping_interval_unit_type: upsellWrapper.dataset.unit,
                      product_handle: upsellWrapper.dataset.handle,
                    },
                    selling_plan: upsellWrapper.dataset.sellingPlan,
                  },
                ],
              };
            } else {
              upsell_data = {
                items: [
                  {
                    quantity: 1,
                    id: upsellProductElement.getAttribute("data-variant-id"),
                  },
                ],
              };
            }

            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(upsell_data),
            })
              .then((response) => {
                return response.json();
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                fetch(`${routes.cart_add_url}`, config)
                  .then((response) => response.json())
                  .then((response) => {
                    if (response.status) {
                      this.handleErrorMessage(response.description);

                      const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
                      if (!soldOutMessage) return;
                      this.submitButton.setAttribute("aria-disabled", true);
                      this.submitButton.querySelector("span").classList.add("hidden");
                      soldOutMessage.classList.remove("hidden");
                      this.error = true;
                      return;
                    } else if (!this.cart) {
                      window.location = window.routes.cart_url;
                      return;
                    }

                    this.error = false;
                    const quickAddModal = this.closest("quick-add-modal");
                    if (quickAddModal) {
                      document.body.addEventListener(
                        "modalClosed",
                        () => {
                          setTimeout(() => {
                            this.cart.renderContents(response);
                          });
                        },
                        { once: true }
                      );
                      quickAddModal.hide(true);
                    } else {
                      this.cart.renderContents(response);
                    }
                  })
                  .catch((e) => {
                    console.error(e);
                  })
                  .finally(() => {
                    this.submitButton.classList.remove("loading");
                    if (this.cart && this.cart.classList.contains("is-empty"))
                      this.cart.classList.remove("is-empty");
                    if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                    this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                  });
              });
          } else {
            let update = false;
            if (formData.get("properties[_fulfillable_quantity]")) {
              const vairantId = formData.get("id");
              let cart = await fetch("/cart.js");
              cart = await cart.json();
              cart.items.forEach((i) => {
                if (i.variant_id == vairantId) {
                  let properties = i.properties;
                  let old_fulfillable_quantity = parseInt(properties['_fulfillable_quantity']);
                  delete properties['_fulfillable_quantity'];
                  let matched = true;
                  let loadSideCart = (result) => {
                    console.log(result);
                    const quickAddModal = this.closest("quick-add-modal");
                    if (quickAddModal) {
                      document.body.addEventListener(
                        "modalClosed",
                        () => {
                          setTimeout(() => {
                            this.cart.renderContents(result);
                          });
                        },
                        { once: true }
                      );
                      quickAddModal.hide(true);
                    } else {
                      this.cart.renderContents(result);
                    }
                  };
                  loadSideCart.bind(this);
                  for (const [key, value] of Object.entries(properties)) {
                    if (formData.get(`properties[${key}]`)) {
                      if (formData.get(`properties[${key}]`) != `${value}`) {
                        matched = false;
                        console.log("value is not matched");
                      }
                    } else {
                      matched = false;
                      console.log("Missing properties");
                    }

                    let quantity_value = parseInt(this.quantitySelector.value);

                    if (matched) {
                      properties.fulfillable_quantity =
                        old_fulfillable_quantity +
                        parseInt(this.form[`properties[_fulfillable_quantity]`].value) *
                          quantity_value;
                      let data = {
                        id: `${i.key}`,
                        quantity: i.quantity + quantity_value,
                        properties: properties,
                        sections: this.cart.getSectionsToRender().map((section) => section.id),
                        sections_url: window.location.pathname,
                      };
                      $.ajax({
                        url: "/cart/change.js",
                        type: "POST",
                        data: data,
                        dataType: "json",
                        success: (result) => loadSideCart(result),
                        error: function (error) {
                          console.log(error);
                        },
                      });

                      update = true;
                      break;
                    }
                  }
                }
              });
            }
            if (!update) {
              if (this.form[`properties[_fulfillable_quantity]`]) {
                let fulfillable_properties_value =
                  parseInt(this.quantitySelector.value) *
                  parseInt(this.form[`properties[_fulfillable_quantity]`].value);
                config.body.set("properties[_fulfillable_quantity]", fulfillable_properties_value);
              }

              fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    this.handleErrorMessage(response.description);

                    const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
                    if (!soldOutMessage) return;
                    this.submitButton.setAttribute("aria-disabled", true);
                    this.submitButton.querySelector("span").classList.add("hidden");
                    soldOutMessage.classList.remove("hidden");
                    this.error = true;

                    return;
                  } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }
                  console.log(response);
                  this.error = false;
                  const quickAddModal = this.closest("quick-add-modal");
                  if (quickAddModal) {
                    document.body.addEventListener(
                      "modalClosed",
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(response);
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    this.cart.renderContents(response);
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  this.submitButton.classList.remove("loading");
                  if (this.cart && this.cart.classList.contains("is-empty"))
                    this.cart.classList.remove("is-empty");
                  if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                  this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                });
            } else {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error) this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add("hidden");
            }
          }
        }

        const ASSORTMENT_KEYS_TO_DISPLAY_NAMES = {
          "_SKU:LTPA": "Light",
          "_SKU:RCPT": "Regular",
          "_SKU:RTPOT": "Regular",
          "_SKU:RTNOT": "Regular",
          "_SKU:SCPT": "Super",
          "_SKU:STPOT": "Super",
          "_SKU:STNOT": "Super",
          "_SKU:PCPT": "Super+",
          "_SKU:PTPOT": "Super+",
          "_SKU:PTNOT": "Super+",
          "_SKU:RPOC": "Regular",
          "_SKU:HPOC": "Heavy",
        };

        setTimeout(() => {
          document.querySelectorAll(".upcart-product-item").forEach((row) => {
            const lineItem = JSON.parse(row.getAttribute("data-upcart-line-item"));
            const customProperties = document.createElement("div");
            customProperties.classList.add("custom-properties");
            if (lineItem.properties?._fulfillable_quantity) {
              const recurringCountContainer = document.createElement("div");
              recurringCountContainer.classList.add("recurring-count-container");
              const recurringCount = document.createElement("span");
              recurringCount.style.fontSize = "12px";
              recurringCount.classList.add("recurring-count");
              recurringCount.innerHTML =
                "<strong>" +
                lineItem.properties[`_fulfillable_quantity`] +
                "</strong> " +
                "<span>Boxes Delivered</span>";
              recurringCountContainer.appendChild(recurringCount);
              customProperties.appendChild(recurringCountContainer);
            }

            const assortmentDescription = document.createElement("div");
            assortmentDescription.classList.add("assortment-description");
            assortmentDescription.style.display = "flex";
            assortmentDescription.style.gap = "6px";
            Object.entries(ASSORTMENT_KEYS_TO_DISPLAY_NAMES).forEach(([key, displayName]) => {
              const value = lineItem.properties?.[key];
              if (value && value !== "0") {
                const description = document.createElement("span");
                description.style.fontSize = "12px";
                description.innerHTML =
                  "<strong>" + value + "</strong> " + "<span>" + displayName + "</span>";
                assortmentDescription.appendChild(description);
              }
            });
            console.log("assortmentDescription: ", assortmentDescription);
            console.log(assortmentDescription.childElementCount);
            if (assortmentDescription.childElementCount === 0) {
              const description = document.createElement("span");
              description.style.fontSize = "12px";
              console.log("lineItem.variant_title: ", lineItem.variant_title);
              if (lineItem.variant_title) {
                description.innerHTML = "<span>" + lineItem.variant_title + "</span>";
              }
              assortmentDescription.appendChild(description);
            }
            customProperties.appendChild(assortmentDescription);
            row.querySelectorAll(".custom-properties").forEach((el) => el.remove());
            row
              .querySelector(".upcart-item-properties-anchor-before")
              ?.appendChild(customProperties);
          });
        }, 1500);
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

var quickFormAssortOptionsElement = document.querySelectorAll(
  "quick-add-modal .assortments--mobile .option"
);
var quickFormPropertyElement = document.querySelectorAll(
  'quick-add-modal .assortment-property[type="hidden"]'
);

if (quickFormAssortOptionsElement.length) {
  quickFormAssortOptionsElement.forEach((optionElement) => {
    optionElement.addEventListener("click", function (e) {
      e.stopPropagation();
      quickFormAssortOptionsElement.forEach((optionEl) => {
        if (optionEl.getAttribute("data-option") == optionElement.getAttribute("data-option")) {
          optionEl.classList.add("active");

          let variantInput = document.querySelector(
            "product-form.quick-view-product-form input[name=id]"
          );
          if (document.querySelector("product-form.quick-view-product-form") && variantInput) {
            variantInput.value = optionEl.getAttribute("data-variant-id");
          }
        } else {
          optionEl.classList.remove("active");
        }
      });

      if (quickFormPropertyElement.length) {
        quickFormPropertyElement.forEach((el) => {
          let elementLocator = el.dataset.option.replace("+", "-plus");

          if (el.getAttribute("data-option") == optionElement.getAttribute("data-option")) {
            el.value = optionElement.getAttribute("data-total-count");
            if (document.querySelector(`quick-add-modal #quickAdd_sku_${elementLocator}`)) {
              document.querySelector(`quick-add-modal #quickAdd_sku_${elementLocator}`).value =
                optionElement.getAttribute("data-total-count");
            }
          } else {
            el.value = 0;
            if (document.querySelector(`quick-add-modal #quickAdd_sku_${elementLocator}`)) {
              document.querySelector(`quick-add-modal #quickAdd_sku_${elementLocator}`).value = 0;
            }
          }
        });
      }

      document.querySelector("quick-add-modal .assortments--mobile .absorbency span").innerHTML =
        "All " + optionElement.getAttribute("data-option");
    });
  });
}
